import { useState } from 'react';
import { TableInput } from '../../../../components/common';

interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
  moduleData: any;
  isView: boolean;
}
const TFoot = ({ preparedBy, approvedBy, moduleData, isView }: Ifoot) => {
  const [render, setRender] = useState(false);
  return (
    <tfoot>
      <tr>
        <th colSpan={3} align="right">
          Operator Sign :-
        </th>
        <th colSpan={32} align="left">
          <TableInput
            isView={isView}
            name="operator_signature"
            type="text"
            value={moduleData.operator_signature}
            onChange={(e) => {
              moduleData.operator_signature = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={3} align="right">
          Supervisor sign. :-
        </th>
        <th colSpan={32} align="left">
          <TableInput
            isView={isView}
            name="supervisor_signature"
            type="text"
            value={moduleData.supervisor_signature}
            onChange={(e) => {
              moduleData.supervisor_signature = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={35} align="left">
          Remarks:
          <TableInput
            isView={isView}
            name="remarks"
            type="text"
            value={moduleData.remarks}
            onChange={(e) => {
              moduleData.remarks = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={17} align="left">
          Prepared By: {preparedBy}
        </th>
        <th colSpan={18} align="left">
          Approved By: {approvedBy}
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
